import { IAnnualReport } from '@modeso/types__aumico-lib-annualreport-be';

export interface CreateAnnualReportResponseDto {
    annualReport: IAnnualReport;
    annualReportEncryptedId: string;
    annualReportMetaInformationId: string;
    projectId: string;
}
